export enum UnitCode {
  lt,
  hl,
  kg,
  t,
}
